import React from 'react';
import { fallbackContent } from '../hooks/useContent';

const Products = ({ items = fallbackContent.offerings }) => {
  return (
    <section className="py-20 lg:py-28 bg-[#f5f5f8]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <p className="section-label text-[#c9a227] mb-3">Products &amp; Packages</p>
        <h2 className="font-display font-bold text-[#12263f] text-4xl lg:text-5xl">Popular Offerings</h2>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((o, i) => (
            <div key={i} className="group flex items-center justify-between gap-4 bg-white rounded-xl px-6 py-5 border border-gray-100 hover:shadow-md hover:border-gray-200 transition-all">
              <span className="text-[15px] text-gray-700 font-medium leading-snug">{o.name}</span>
              <span className="font-display font-bold text-[#12263f] whitespace-nowrap group-hover:text-[#c9a227] transition-colors">{o.price}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Products;
